
import React from 'react';
import PageHeader from '../components/PageHeader';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | LovaBuild</title>
        <meta name="description" content="Privacy policy for LovaBuild services" />
      </Helmet>
      
      <PageHeader title="Privacy Policy" />
      
      <div className="container mx-auto px-6 py-12">
        <div className="max-w-4xl mx-auto prose prose-lg">
          <p className="text-lg text-luxury-600 mb-6">Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
          
          <h2 className="text-2xl font-display font-bold mb-4">1. Introduction</h2>
          <p>
            LovaBuild ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services.
          </p>
          
          <h2 className="text-2xl font-display font-bold mb-4 mt-8">2. Information We Collect</h2>
          <p>We may collect information about you in various ways, including:</p>
          <ul className="list-disc pl-6 mb-6">
            <li>Personal Data: Name, email address, phone number, and other contact details you provide.</li>
            <li>Usage Data: Information about how you use our website and services.</li>
            <li>Device Data: Information about your device, IP address, browser type, and operating system.</li>
          </ul>
          
          <h2 className="text-2xl font-display font-bold mb-4 mt-8">3. How We Use Your Information</h2>
          <p>We may use the information we collect for various purposes, including:</p>
          <ul className="list-disc pl-6 mb-6">
            <li>To provide and maintain our services</li>
            <li>To notify you about changes to our services</li>
            <li>To provide customer support</li>
            <li>To gather analysis or valuable information to improve our services</li>
            <li>To monitor the usage of our services</li>
            <li>To detect, prevent, and address technical issues</li>
          </ul>
          
          <h2 className="text-2xl font-display font-bold mb-4 mt-8">4. Disclosure of Your Information</h2>
          <p>We may share your information with:</p>
          <ul className="list-disc pl-6 mb-6">
            <li>Service providers we use to support our business</li>
            <li>Business partners with your consent</li>
            <li>Law enforcement agencies when required by law</li>
            <li>In connection with a business transaction such as a merger or acquisition</li>
          </ul>
          
          <h2 className="text-2xl font-display font-bold mb-4 mt-8">5. Your Privacy Rights</h2>
          <p>
            Depending on your location, you may have certain rights regarding your personal information, such as the right to access, correct, or delete your data.
          </p>
          
          <h2 className="text-2xl font-display font-bold mb-4 mt-8">6. Data Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
          </p>
          
          <h2 className="text-2xl font-display font-bold mb-4 mt-8">7. Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
          </p>
          
          <h2 className="text-2xl font-display font-bold mb-4 mt-8">8. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p className="mt-2">
            <strong>Email:</strong> privacy@lovabuild.com
          </p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
